import React from 'react';
import * as FlexWebChat from "@twilio/flex-webchat-ui";

class App extends React.Component {

  state = {};

  constructor(props) {
    super(props);

    const { configuration } = props;
    FlexWebChat.Manager.create(configuration)
      .then((manager) => {
        manager.strings = {
          EntryPointTagline: "Fale com a gente",
          MessageCanvasTrayContent: ` 
              <h6>Obrigado pelo contato!</h6>
              <p>Caso ainda tenha dúvidas, por favor entre em contato conosco novamente.</p>`,
          PredefinedChatMessageAuthorName: "SUPERMED",
          MessageCanvasTrayButton: "INICIAR NOVA CONVERSA",
          FileAttachmentDropAreaSubtitle: "Solte o arquivo aqui",
          InputPlaceHolder: "Escreva uma mensagem...",
          FileAttachmentDropAreaTitle: "Anexar imagem ou arquivo",
          PredefinedChatMessageBody: "Olá! Como posso te ajudar?",
          NewChatMessageNotificationTitle: "Nova mensagem de {{lastMessage.authorName}}",
          WelcomeMessage: "Bem-vindo(a) ao atendimento Supermed",
          PendingEngagementCancelButton: "Cancelar",
          DownloadFileInvalidSize: "{{fileName}} é muito grande para baixar. O tamanho máximo pertimitido é {{maxFileSize}}.",
          DownloadFileInvalidType: "{{fileName}} não pode ser baixado pois o tipo do arquivo não é suportado.",
          DownloadFileNotParticipant: "Não foi possível baixar o arquivo. Você não é participante deste chat.",
          MediaMessageClickToOpen: "Abrir arquivo",
          FilterItemAmountSelected: "{{amount}} selecionado(s)",
          MessageCharacterCountStatus: "{{currentCharCount}} / {{maxCharCount}}",
          ConfirmEndEngagementMessage: "Tem certeza que quer encerrar o chat?",
          TypingIndicator: "{{name}} está digitando ... ",
          MessageCharacterCountReached: "Limite de caracteres atingido - {{currentCharCount}} / {{maxCharCount}}",
          MessageSendingDisabled: "Enviar mensagem desabilitado",
          InvalidPreEngagementButton: "Leia mais",
          Connecting: "Conectando …",
          Today: "HOJE",
          Yesterday: "ONTEM",
          Read: "Lida",
          PreEngagementMandatoryFieldMessage: "Campo obrigatório *",
          NewChatMessageNotificationBody: "{{#if lastMessage.body}} {{lastMessage.body}} {{else}} arquivo enviado {{/if}}",
          PendingEngagementMessage: "Aguarde enquanto te conectamos com um agente disponível"
        }
        this.setState({manager})
      }).catch((error)=>this.setState({error}))
  }

  render() {
    const { manager, error } = this.state;
    if (manager) {
      return (
        <FlexWebChat.ContextProvider manager={manager}>
          <FlexWebChat.RootContainer />
        </FlexWebChat.ContextProvider>
      );
    }

    if (error) {
      console.error("Falha ao iniciar Flex Web Chat", error);
    }

    return null;
  }
}

export default App;
